import { createHTTPClient } from "@airhelp/http-client";
import { caller, queryStringAddon, valid, snakeCaseBody } from "@airhelp/http-client/addons";
import { csrf } from "@airhelp/http-client/middleware";
import { a6, a5, l, q, E, u, t, v, w, b, c, a, a1, a0, o, k, n, s, p, r, e, f, d, T, Z, X, Y, $, _, W, U, V, R, S, z, x, h, g, C, A, B, H, F, j, i, D, y, m, G, K, I, J, M, L, O, N, Q, P, a4, a3, a2 } from "./accept-marketing-consent-C0bmbSyk.js";
function createBaseWebappHTTPClient({
  caller: caller$1,
  options,
  baseURL
}) {
  return createHTTPClient({
    baseURL,
    options: {
      credentials: "include",
      ...options
    }
  }).addon(caller).addon(queryStringAddon).addon(valid()).addon(snakeCaseBody()).middlewares([csrf()]).caller(caller$1).headers({
    // Webapp will only send the CSRF if the
    // X-Requested-With header is set to XMLHttpRequest
    "X-Requested-With": "XMLHttpRequest"
  });
}
function destroySession({ client }) {
  return client.url("/api/session").delete().text();
}
export {
  a6 as acceptMarketingConsent,
  a5 as acceptMarketingConsentResponseSchema,
  l as airlineSchema,
  q as airportSchema,
  E as claimPayoutSchema,
  u as confirmPayout,
  t as confirmPayoutRequestSchema,
  createBaseWebappHTTPClient,
  v as createCreditCardRequestSchema,
  w as createCreditCardTransfer,
  b as createUser,
  c as createUserRequestSchema,
  a as createUserResponseSchema,
  a1 as deleteClaimEnquiry,
  a0 as deleteClaimEnquiryRequestSchema,
  destroySession,
  o as fetchAirlines,
  k as fetchAirlinesRequestSchema,
  n as fetchAirlinesResponseSchema,
  s as fetchAirports,
  p as fetchAirportsRequestSchema,
  r as fetchAirportsResponseSchema,
  e as fetchBrand,
  f as fetchBrandRequestSchema,
  d as fetchBrandResponseSchema,
  T as fetchClaim,
  Z as fetchClaimCommunicationHistory,
  X as fetchClaimCommunicationHistoryRequestSchema,
  Y as fetchClaimCommunicationHistoryResponseSchema,
  $ as fetchClaimEnquiries,
  _ as fetchClaimEnquiriesResponseSchema,
  W as fetchClaimHistory,
  U as fetchClaimHistoryRequestSchema,
  V as fetchClaimHistoryResponseSchema,
  R as fetchClaimRequestSchema,
  S as fetchClaimResponseSchema,
  z as fetchCurrencyExchangeRateForTargetCountry,
  x as fetchCurrencyExchangeRateForTargetCountryRequestSchema,
  h as fetchCurrentUserProfile,
  g as fetchCurrentUserProfileResponseSchema,
  C as fetchPaymentReferenceData,
  A as fetchPaymentReferenceDataRequestSchema,
  B as fetchPaymentReferenceDataResponseSchema,
  H as fetchPayoutClaim,
  F as fetchPayoutClaimRequestSchema,
  j as fetchTrustpilotScore,
  i as fetchTrustpilotScoreResponseSchema,
  D as getEnabledPayoutOptions,
  y as makeFetchCurrencyExchangeRateForTargetCountryRoute,
  m as makeFetchCurrentUserProfileRoute,
  G as makeFetchPayoutClaimRoute,
  K as postBankTransferDetails,
  I as postBankTransferDetailsRequestSchema,
  J as postBankTransferDetailsResponseSchema,
  M as postChequeDetails,
  L as postChequeDetailsRequestSchema,
  O as postPaypalDetails,
  N as postPaypalDetailsRequestSchema,
  Q as putPayoutDetails,
  P as putPayoutDetailsRequestSchema,
  a4 as updateUserProfile,
  a3 as updateUserProfileRequestSchema,
  a2 as updateUserProfileSchema
};
//# sourceMappingURL=index.js.map
